<template>
  <div>
    <div>
      <div class="content-wrapper">
        <div class="row">
          <div class="col-md-12 grid-margin">
            <div class="row">
              <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                <h3 class="font-weight-bold">สาขาที่เปิดรับในงาน Open house</h3>
                <h6 class="font-weight-normal mb-0">
                  ประจำปี 2565 วันที่ 8-9 ธันวาคม
                  <span class="text-primary"></span>
                </h6>
              </div>
              <div class="col-12 col-xl-4">
                <div class="justify-content-end d-flex">
                  <div class="dropdown flex-md-grow-1 flex-xl-grow-0"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 grid-margin stretch-card">
            <div class="card tale-bg">
              <div class="card-people mt-auto">
                <!-- <img src="images/map_openhouse.png" alt="people" /> -->
                <div class="weather-info">
                  <div class="d-flex"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 grid-margin transparent">
            <div class="row"></div>
            <div class="row">
              <div class="col-md-6 mb-4 stretch-card transparent">
                <div class="card card-dark-blue">
                  <div class="card-body center">
                    <a href="pagebranch" class="btn btn-primary py-3 px-4"
                      >สาขาที่เปิดรับ</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageBranch",
};
</script>

<style></style>
